import Vue from 'vue'
import Vuex from 'vuex'

import mutations from './mutations'
import getter from './getter'
import actions from './actions'

Vue.use(Vuex)
const store = new Vuex.Store({
	state:{
		debug:false,
		apiUrl:'',	//不填就获取当前域名
		token:'',
		nowRouteName:'',	//当前路由名称
		isMobile:false,	//是否移动端
		winW:0,		//浏览器高度
		winH:0,		//浏览器高度
		lan:'en',
		otherData:null,	//其他一些配置
		friendLink:null,	//友情链接
		
		uuid:'',	//用户临时id
	},
	mutations,
	getter,
	actions
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js